module.exports = __webpack_public_path__ + "static/media/3_Foiled_03.826ad45b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/3_Foiled_03.jpg
// module id = 1708
// module chunks = 0